'use client';

import { Box, Button, Container, Heading, Hidden, Image, Text } from '@doist/marketist';
import { type PrefooterVariant } from 'app/services/get-prefooter-colors';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import { registerUrl } from 'services/authUrls';
import css from './prefooter.module.css';
export type PrefooterProps = {
  title: React.ReactNode;
  subtitle: string;
  backgroundColor: string;
  variant?: PrefooterVariant;
  illustration: {
    src: string;
    width: number;
    height: number;
  };
};
export function Prefooter({
  title,
  subtitle,
  backgroundColor,
  illustration
}: PrefooterProps) {
  const {
    t
  } = useTranslation('common');
  return <Box className={css.wrapper} style={{
    '--footer-background': backgroundColor
  }} data-sentry-element="Box" data-sentry-component="Prefooter" data-sentry-source-file="prefooter.tsx">
            <Container className={css.section} data-sentry-element="Container" data-sentry-source-file="prefooter.tsx">
                <Image src={illustration.src} width={illustration.width} height={illustration.height} className={css.illustration} alt="" data-sentry-element="Image" data-sentry-source-file="prefooter.tsx" />
                <Box className={css.cta} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                    <Heading level="3" size="major-xl" data-sentry-element="Heading" data-sentry-source-file="prefooter.tsx">
                        {title}
                    </Heading>
                    <Hidden below="md" data-sentry-element="Hidden" data-sentry-source-file="prefooter.tsx">
                        <Text size="body-lg" className={cn(css.text, 'mbs-24')} data-sentry-element="Text" data-sentry-source-file="prefooter.tsx">
                            {subtitle}
                        </Text>
                    </Hidden>
                    <Button size="large" className="mbs-24 md-mbs-32" href={registerUrl} data-sentry-element="Button" data-sentry-source-file="prefooter.tsx">
                        {t('getStartedForFree')}
                    </Button>
                </Box>
            </Container>
        </Box>;
}